import api from './api';

/**
 * One carrier row from GET /cms-lookups/carrier-search (active highway carriers,
 * name-prefix match). The stored FK is `recno` (the carriercode written to
 * ordersall.carriercode); `name` is the display truckername. Reusable anywhere a
 * carrier is picked — mirrors the ports.service / PortLookupField pattern.
 */
export interface CarrierRow {
  recno: number; // 0 = unlinked
  name: string;
  scac: string;
  mcnum: string;
  dotnum: string;
  city: string;
  state: string;
}

/** Enriched carrier typeahead — matches carrier name prefix. Min 2 chars.
 *  Maps the backend response (which also returns address/zip/confirmed) down to
 *  the fields the picker renders. */
export async function searchCarriers(q: string): Promise<CarrierRow[]> {
  const res = await api.get('/cms-lookups/carrier-search', { params: { q } });
  const rows = (res.data ?? []) as Array<{
    recno: number;
    name: string;
    scac: string;
    mcnum: string;
    dotnum: string;
    city: string;
    state: string;
  }>;
  return rows.map((r) => ({
    recno: r.recno,
    name: r.name ?? '',
    scac: r.scac ?? '',
    mcnum: r.mcnum ?? '',
    dotnum: r.dotnum ?? '',
    city: r.city ?? '',
    state: r.state ?? '',
  }));
}
